import { Component, ChangeDetectionStrategy } from '@angular/core';
import { EmbeddedReportService } from "../components/embedded-report/embedded-report.service";
import { combineLatest, Subscription } from "rxjs";
import { SafeResourceUrl } from "@angular/platform-browser";

@Component({
  selector: 'app-dashboard',
  imports: [],
  templateUrl: './dashboard.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent {

  url: SafeResourceUrl;

  sub:Subscription;
  constructor(private reports: EmbeddedReportService) {
  }

  ngOnInit() {
    this.reports.getReports();
    this.sub = combineLatest({
      reports: this.reports.reports$,
      url: this.reports.url$,
    }).subscribe(({reports, url}) => {
      if(reports.length > 0) {
        this.reports.selectReport('Dashboards');
        this.reports.setFilters({});
      }
      if(url){
        this.url = url;
      }
    });
  }
}
